import axios from "axios";
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    lista: [],
    dt1: moment().format('YYYY-MM-DD'),
    dt2: moment().format('YYYY-MM-DD'),
    status: '',
    registroSelecionadoId: null
  },
  getters: {
    LISTA: state => state.lista,
    DT1: state => state.dt1,
    DT2: state => state.dt2,
    STATUS: state => state.status,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId
  },
  mutations: {
    SET_LISTA: (state, payload) => {
      state.lista = payload
    },
    SET_DT1: (state, payload) => {
      state.dt1 = payload
    },
    SET_DT2: (state, payload) => {
      state.dt2 = payload
    },
    SET_STATUS: (state, payload) => {
      state.status = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
      state.registroSelecionadoId = payload
    },
    SET_LIMPAR: (state) => {
      state.lista = []
      state.dt1 = moment().format('YYYY-MM-DD')
      state.dt2 = moment().format('YYYY-MM-DD')
      state.status = ''
    }
  },
  actions: {
    GERAR_LISTA: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        let uri = `/api/protected/ordementrega/pesquisar?dt1=${getters.DT1 || ''}&dt2=${getters.DT2 || ''}`
        if (getters.STATUS) {
          uri += `&status=${getters.STATUS}`
        }

        axios
          .get(uri)
          .then(({ data, status }) => {
            commit("SET_LISTA", data);
            if (status === 200 || status === 201) {
              resolve({ data, status });
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/ordem-entrega-store.js